import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipGroup, TooltipGroupAnchor } from '@/components/shared/tooltip/TooltipGroup';
import Link from '@/storybook/components/Link/Link';
import Text from '@/storybook/components/Text/Text';
import { AppRoutes } from '@/utils/constants';
import { TestIds } from './testIds';
import styles from './ChatDisclaimer.module.css';

export interface ChatDisclaimerProps {
  onLearnMoreClick?: () => void;
}

const ChatDisclaimer: FC<ChatDisclaimerProps> = ({ onLearnMoreClick }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.disclaimer} data-testid={TestIds.disclaimer}>
      <Text as="small" className={styles.text}>
        {t('components.aiChatDrawer.disclaimer.text')}
      </Text>
      <div className={styles.learnMoreGroup}>
        <TooltipGroup id="ai-chat-disclaimer-tooltip" shouldShowForTruncatedOnly={false}>
          <TooltipGroupAnchor
            value={t('components.aiChatDrawer.disclaimer.learnMoreTooltip')}
            place="top"
            forceDisplayTooltip
            className={styles.learnMoreAnchor}
          >
            <Link
              to={AppRoutes.DISCLAIMER_PAGE}
              className={styles.learnMore}
              data-testid={TestIds.learnMore}
              onClick={onLearnMoreClick}
            >
              {t('components.aiChatDrawer.disclaimer.learnMore')}
            </Link>
          </TooltipGroupAnchor>
        </TooltipGroup>
      </div>
    </div>
  );
};

export default ChatDisclaimer;
